import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import store from './store'
import { observer } from 'mobx-react'
import { JUKE_PATH_A } from '@constant'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      params: { id }
    } = props
    store.id = id
  }

  componentDidMount() {
    store.getInfo()
  }

  render() {
    const header = [
      <a style={{ color: '#333', marginRight: 5 }} href={JUKE_PATH_A}>
        聚客宝
      </a>,
      <a style={{ color: '#333', marginRight: 5 }} href={`${JUKE_PATH_A}/old`}>
        旧版聚客宝
      </a>,
      '活动详情'
    ]

    const {
      data: {
        status = 0,
        reason,
        created_at,
        title,
        activity_title,
        has_prize = 0,
        people_limit,
        activity_time,
        content,
        merchant_info,
        imgs,
        gift
      }
    } = store

    return (
      <HeaderView header={header} title="活动详情">
        <div className={styles.box}>
          <div className={styles.status}>
            {(status == 0 || status == 3) && <span>审核中</span>}
            {status == 1 && <span>审核通过（即将上线）</span>}
            {status == 2 && <span>审核不通过</span>}
            {status == 2 && reason && <p>原因：{reason}</p>}
          </div>

          <div className={styles.item}>
            <span className={styles.label}>申请时间</span>
            <div className={styles.txt}>{created_at}</div>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>活动主题</span>
            <div className={styles.txt}>{title || activity_title}</div>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>是否抽奖</span>
            <div className={styles.txt}>{has_prize == 0 ? '否' : '是'}</div>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>活动名额</span>
            <div className={styles.txt}>
              {people_limit ? people_limit : '不限'}
            </div>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>活动时间</span>
            <div className={styles.txt}>{activity_time}</div>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>活动内容</span>
            <div className={styles.txt}>{content}</div>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>商家简介</span>
            <div className={styles.txt}>{merchant_info}</div>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>活动图片</span>
            <div className={styles.txt}>
              {/*<ImgBox imgs={imgs}  keyField={'img'} preWidth={700} preHeight={700} imgW={120} imgH={140}/>*/}
              {imgs &&
                JSON.parse(imgs).map((item, index) => (
                  <img key={index} src={item.img} />
                ))}
            </div>
          </div>

          <p className={styles.other}>
            其他信息（以下礼品将只针对报名且到店的用户，非中奖用户也可以领取。如填写，请勿与店铺本身到店礼、订单礼重复）
          </p>

          <div className={styles.item}>
            <span className={styles.label}>到店礼</span>
            <div className={styles.txt}>
              {gift
                ? JSON.parse(gift).visit_gift
                  ? JSON.parse(gift).visit_gift
                  : '无'
                : '无'}
            </div>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>好评礼</span>
            <div className={styles.txt}>
              {gift
                ? JSON.parse(gift).comment_gift
                  ? JSON.parse(gift).comment_gift
                  : '无'
                : '无'}
            </div>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>下单礼</span>
            <div className={styles.txt}>
              {gift
                ? JSON.parse(gift).order_gift
                  ? JSON.parse(gift).order_gift
                  : '无'
                : '无'}
            </div>
          </div>
        </div>
      </HeaderView>
    )
  }
}
